import { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { DEACTIVATE_PLAYER_PASSWORD_TIMEOUT } from "../../utils/constants";
import { playerActivationStore } from "../../utils/firebase";
import { offlineStore } from "../../utils/offlineStore";
import { PlayerDeactivate } from "../PlayerAuth";
import { OfflineExpiredBlock } from "../components/OfflineExpiredBlock";

export const PlayerAuthRoute = ({
	children,
}: { children: React.ReactNode }) => {
	const [isPasswordRequested, setIsPasswordRequested] = useState(false);
	const [isGraceExpired, setIsGraceExpired] = useState(
		offlineStore.isGracePeriodExpired,
	);

	useEffect(() => {
		if (!window.api?.isInstalledPlayer) {
			return;
		}

		let timeout: ReturnType<typeof setTimeout> | undefined;
		const handleRequestPassword = () => {
			setIsPasswordRequested(true);
			clearTimeout(timeout);
			timeout = setTimeout(() => {
				setIsPasswordRequested(false);
			}, DEACTIVATE_PLAYER_PASSWORD_TIMEOUT);
		};

		window.api.onRequestPassword(handleRequestPassword);
		return () => {
			clearTimeout(timeout);
			// Older installed shells don't expose offRequestPassword
			window.api?.offRequestPassword?.(handleRequestPassword);
		};
	}, []);

	// The kiosk can sit for weeks without re-rendering; re-check the grace
	// period on an interval so the block screen appears without interaction
	useEffect(() => {
		const interval = setInterval(() => {
			setIsGraceExpired(offlineStore.isGracePeriodExpired);
		}, 60 * 1000);
		return () => clearInterval(interval);
	}, []);

	if (isPasswordRequested) {
		return <PlayerDeactivate />;
	}

	// Valida ativação completa (activated + password)
	if (!playerActivationStore.isValid) {
		// Se ativação incompleta/corrompida, limpa e redireciona
		if (playerActivationStore.isActivated) {
			playerActivationStore.clear();
		}
		return <Navigate to="/" />;
	}

	// Offline lock disabled: boot-time clock skew (app starts before NTP
	// syncs) can stamp lastVerified months in the past and lock instantly.
	// Re-enable only after lastVerified is made clock-skew safe.
	const OFFLINE_LOCK_ENABLED = false;

	// Verifica período de graça offline (ver GRACE_PERIOD_DAYS)
	if (OFFLINE_LOCK_ENABLED && isGraceExpired) {
		return <OfflineExpiredBlock onExtended={() => setIsGraceExpired(false)} />;
	}

	return <>{children}</>;
};
